import React from 'react'
import styles from './PayerCard.styles'
import CardWCheckbox from '../../../../components/card/cardwcheckbox/CardWCheckbox'
import Payer from "../../../../../libs/utility/Payer"
import Icons from '../../../../components/icons/Icons'
import { VEC_ICON_NAME } from '../../../../components/icons/constants'
import Label from '../../../../components/label/Label'
import VerticalSeparator from '../../../../components/separator/verticalseparator/VerticalSeparator'
import useFormatTIN from '../../../../../libs/customhooks/useFormatTIN'

export default function PayerCard({
    payer = {},
    isSelected = false,
    onChangeCheckboxCb = () => { },
    onCardClickCb = () => { },
    isHighlighted = false,
    payerCount = 0,
    recipitentCount = 0
}) {

    const { formatTIN } = useFormatTIN() 

    const { FirstName = "", LastName, IdType, IdNumber, hideTIN, FileType, payerName } = payer;

    return (
        <>
            <CardWCheckbox
                isSelected={isSelected}
                onChangeCb={onChangeCheckboxCb}
                isHighlighted={isHighlighted}
                onCardClickCb={onCardClickCb}
                containerStyle={styles.cursor}
            >

                <div style={styles.payerInformationContainer}>
                    <Label customStyles={styles.payerName}>{FirstName} {LastName}</Label>
                    <Label customStyles={styles.payerName}>{payerName}</Label>

                    <div style={styles.detailsContainer}>
                        <div style={styles.payerType}>
                            <span>{FileType}</span>
                            <VerticalSeparator style={styles.separator} />

                            <div style={styles.gapBetween}>

                                <span>{formatTIN(IdType, IdNumber, hideTIN ?? true) || "N/A"}</span>

                                {payerCount !== 0 && (
                                    <>
                                        <Icons
                                            familyName='vec'
                                            iconName={VEC_ICON_NAME.TRADE_ICON}
                                        />
                                        <span style={styles.infoCount}>{payerCount}</span>
                                    </>
                                )}
                            </div>
                        </div>

                        {recipitentCount !== 0 && (
                            <p style={styles.recipientNumber}>
                                {recipitentCount} Recipitents
                            </p>
                        )}
                    </div>
                </div>

            </CardWCheckbox>
        </>
    )
}